module.exports = __webpack_public_path__ + "media/images/front/icon_m_line-3c783b980b4aa46f8fe382d4976a43c1.png";